import Axios from "axios";

import { SET_VOUCHER_LIST, UNSET_VOUCHER_LIST } from "@/store/mutation-types";

import {
  saveUpdateVoucher as saveUpdateApi,
  getVoucherList as getVoucherListApi,
  getVoucherById as getVoucherByIdApi,
  getApprovalRequestRecord as getApprovalRequestRecordApi,
} from "@/store/api";

// Initial State
const state = {
  getVoucherList: [],
  editingVoucher: null,
  viewingVoucher: null,
};

// Getters
const getters = {
  getVoucherList(state) {
    return state.getVoucherList;
  },
  getEditingVoucher: (state) => state.editingVoucher,
  getViewingVoucher: (state) => state.viewingVoucher,
};

// Mutations
const mutations = {
  [SET_VOUCHER_LIST](state, data) {
    state.getVoucherList = data;
  },
  [UNSET_VOUCHER_LIST](state) {
    state.getVoucherList = [];
  },
  setEditingVoucher(state, voucher) {
    state.editingVoucher = voucher;
  },
  setViewingVoucher(state, voucher) {
    state.viewingVoucher = voucher;
  },
};

// Actions
const actions = {
  /**
   * Save or update voucher
   */
  saveUpdateVoucher({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    // console.log(data);
    return new Promise((resolve, reject) => {
      Axios.post(`${saveUpdateApi}/${data.type}/store-update`, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  /**
   * Get voucher list by type
   */
  getVoucherList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${getVoucherListApi}/${data.type}`)
        .then((response) => {
          commit(SET_VOUCHER_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_VOUCHER_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  /**
   * Get approval request records for vouchers
   */
  getApprovalRequestRecord({ commit }, params) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.post(getApprovalRequestRecordApi, params)
        .then((response) => {
          commit(SET_VOUCHER_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_VOUCHER_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // Get Voucher By Id
  getVoucherById({ commit }, data) {
    const getVoucherById = `${getVoucherByIdApi}/${data.slug}/${data.id}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getVoucherById)
        .then((response) => {
          resolve(response.data);
          console.log(response.data.data)
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
